import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  presentationText: {
    whiteSpace: 'pre-wrap'
  }
});
